/** @jsxImportSource @emotion/react */

import { Button } from "antd";
import { memberApi } from "api/member";
import SkeletonCustom from "components/base/SkeletonCustom";
import { ResponseCode } from "constants/response";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { selectUsername } from "store/auth";
import { selectDataMemberVip, selectLoadingDataMemberVip } from "store/member";
import { outletContextType } from "types";

import { VipPointsTurnoverStyle } from "./style";

const VipPointsTurnover = () => {
  const { t } = useTranslation(["vip"]);

  const username = useSelector(selectUsername);

  const { data: memberVIP } = useSelector(selectDataMemberVip);
  const isLoadingVIP = useSelector(selectLoadingDataMemberVip);
  const { openNotification } = useOutletContext<outletContextType>();

  const [vipPointsInput, setVipPointsInput] = useState<string>("");
  const [isLoadingExchange, setIsLoadingExchange] = useState<boolean>(false);

  const ratio = memberVIP?.vip_points_exchange_ratio ?? 0;
  const currentPoints = memberVIP?.vip_points ?? 0;

  const numericPoints = parseFloat(vipPointsInput);
  const amount =
    !isNaN(numericPoints) && numericPoints > 0 ? numericPoints / ratio : 0;

  const handleExchange = async () => {
    if (isNaN(numericPoints) || numericPoints <= 0) {
      openNotification("error", t("ValidVIPPoints"));
      return;
    }

    if (numericPoints > Number(currentPoints)) {
      openNotification(
        "error",
        t("MsgEnoughVIPPoints", { currentPoints: currentPoints })
      );
      return;
    }

    try {
      setIsLoadingExchange(true);
      const res = await memberApi.VipPointsExchange({
        username: username,
        vip_points: Number(numericPoints)
      });
      setIsLoadingExchange(false);
      if (res.status === ResponseCode.SUCCESS) {
        openNotification("success", res.msg);
        setVipPointsInput("");
        window.location.reload();
      } else {
        openNotification("success", res.msg);
      }
    } catch (error) {
      setIsLoadingExchange(false);
      console.error(error);
      openNotification("error", "An error occurred during submission");
    }
  };

  return (
    <div css={VipPointsTurnoverStyle.wrapper}>
      <div css={VipPointsTurnoverStyle.title}>
        {t("VIPPoints")} - {t("Turnover")}
      </div>
      <div css={VipPointsTurnoverStyle.vipPoint}>
        <div className="wrap-item left-box">
          <div className="form-control">
            <div className="form-input">
              <input
                id="points"
                value={vipPointsInput}
                onChange={(e) => setVipPointsInput(e.target.value)}
                type="number"
                className={`form-input`}
                placeholder={t("EnterVIPPoint")}
              />
              <p className="rate title">
                {memberVIP.vip_points_exchange_ratio} {t("VIPPoints")} = 1{" "}
                {t("Amount")}
              </p>
              <p
                className={`rate ${
                  numericPoints > Number(currentPoints) ? "error" : ""
                }`}
              >
                {numericPoints || 0} {t("VIPPoints")} ={" "}
                {amount > 0 ? amount.toFixed(2) : 0} {t("Amount")}
                {numericPoints > Number(currentPoints) && (
                  <span className="warning">{t("warningVIPPoint")}</span>
                )}
              </p>
            </div>
            <Button
              onClick={handleExchange}
              disabled={isLoadingExchange}
              className="btn-exchange"
            >
              {t("Exchange")}
            </Button>
          </div>
        </div>
        <div className="wrap-item right-box">
          <div className="vip-points">
            <span>{t("VIPPoints")}:</span>
            {isLoadingVIP ? (
              <SkeletonCustom height="40px" width="120px" />
            ) : (
              <p>{memberVIP?.vip_points}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default VipPointsTurnover;
